import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../services/attribution';

/**
 * Skickar en sidvisning till Google Analytics vid varje sidbyte i appen.
 * Routern byter sida utan att webbläsaren laddar om eller ger en hashchange,
 * så det måste ske här. Gör inget utan samtycke till statistik.
 */
export const AnalyticsPageViews = () => {
    const location = useLocation();
    useEffect(() => { trackPageView(); }, [location.pathname, location.search]);
    return null;
};
